import type {
  GapAcceptance,
  GapImpact,
  GapOrigin,
  GapWorkaroundType,
} from "@/api/project-gaps";

/*
  Os rótulos de cada vocabulário do GAP (EF-FUNC-011, RF-03), na ordem da EF.
  São chaves do i18n: quem mostra passa por `t()`. O formulário e a lista da
  aba "Registro de GAPs" leem daqui, para os dois dizerem a mesma coisa.
*/

export const ORIGIN_LABELS: Record<GapOrigin, string> = {
  process_no_scope_item: "Process without scope item",
  wricef: "WRICEF (development)",
  chart_of_accounts: "Chart of accounts",
};

export const WORKAROUND_TYPE_LABELS: Record<GapWorkaroundType, string> = {
  manual: "Manual process",
  process_change: "Process change",
  third_party: "Third-party solution / add-on",
  accept_loss: "Accept the loss of functionality",
};

export const IMPACT_LABELS: Record<GapImpact, string> = {
  high: "High impact",
  medium: "Medium impact",
  low: "Low impact",
};

export const ACCEPTANCE_LABELS: Record<GapAcceptance, string> = {
  pending: "Pending",
  discussing: "Under discussion",
  accepted: "Accepted",
};
